<template>
  <div id="attendance-modal-template" class="modal__wrap--bg cmp-modal" :class="{'is-active': showModal}" v-if="showModal">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">출석 확인</div>
      </div>
      <div class="modal-body-container">
        <div class="table-wrap no-line-mg scroll-table">
          <table class="table-list">
            <caption>수강 강좌 목록</caption>
            <colgroup class="pc-cell">
              <col style="width:33%">
              <col style="width:33%">
              <col>
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width:150px">
              <col style="width:450px">
              <col style="width:150px">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">날짜</th>
                <th scope="col">시간</th>
                <th scope="col">출석</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(book, index) in rollbook.rollBookList" :key="index">
                <td class="text-c">{{dateFormat(book.date)}}</td>
                <td class="text-c">{{timeFormat(book.startTime)}}-{{timeFormat(book.endTime)}}</td>
                <td class="text-c"><span class="attendance-label" v-if="book.roll !== ''">{{book.roll}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150  close-modal" @click="$emit('close')">
          닫기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="$emit('close')" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    props: ['showModal', 'courseId'],
    name: 'attendance-modal-template',
    data() {
      return {
        rollbook: {},
      };
    },
    watch: {
      courseId() {
        this.getData();
      },
    },
    methods: {
      getData() {
        axios.get(`/api/courses/${this.courseId}/rollbook`).then((response) => {
          this.rollbook = response.data || [];
        }).catch((error) => {
          console.log(error.data);
        });
      },
      timeFormat(time) {
        return `${time.slice(0, 2)}:${time.slice(2, 4)}`;
      },
      dateFormat(date) {
        return `${date.slice(0, 2)}.${date.slice(2, 4)}.${date.slice(4)}`;
      },
    },
    mounted() {

    },
  };
</script>



// WEBPACK FOOTER //
// AttendanceModal.vue?7aee01f3